import React from 'react';

function SectionLoadingIndicator() {
    return (
        <div style={{position: "absolute", backgroundColor: 'white', right: '10px', top: '10px', zIndex: 2 }} className="loader is-loading"></div>
    );
}

export default SectionLoadingIndicator;
